(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["banner-3-inline"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    document.querySelectorAll('.psb-square-pair[data-mobile-autoplay="true"]').forEach((slider) => {
      if (slider.dataset.mobileAutoplayReady === 'true') return;

      const track = slider.querySelector('.psb-track');
      const slides = Array.from(slider.querySelectorAll('.psb-slide'));
      if (!track || slides.length < 2) return;

      slider.dataset.mobileAutoplayReady = 'true';
      const interval = Number.parseInt(slider.dataset.mobileInterval, 10) || 7000;
      const mobile = window.matchMedia('(max-width: 749px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activeIndex = 0;
      let timer;

      const show = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        track.style.transform = `translateX(-${activeIndex * 100}%)`;
      };

      const stop = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = undefined;
        }
      };

      const start = () => {
        stop();
        if (!mobile.matches || reducedMotion.matches || document.hidden) return;
        timer = window.setInterval(() => show(activeIndex + 1), interval);
      };

      mobile.addEventListener('change', () => {
        show(0);
        start();
      });
      reducedMotion.addEventListener('change', start);
      document.addEventListener('visibilitychange', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', start);
      start();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
